import React from 'react';
import SalesIndex from '../join';

export default function () {
  return <SalesIndex noFixedVideo noExitIntent ctaNoTimer variant="ad" />;
}
